import React from 'react';

const KorshaLogo = ({ size = 34, opacity = 0.6 }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" fill="none">
    <circle cx="40" cy="40" r="38" stroke="#8A6BC4" strokeWidth="2" opacity={opacity} />
    <path d="M52 18 L26 40 L52 62" stroke="#8A6BC4" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="40" cy="14" r="3" fill="#C9B0E9" opacity=".8" />
    <circle cx="66" cy="40" r="3" fill="#C9B0E9" opacity=".8" />
    <circle cx="40" cy="66" r="3" fill="#C9B0E9" opacity=".8" />
    <circle cx="14" cy="40" r="3" fill="#C9B0E9" opacity=".8" />
  </svg>
);

export default KorshaLogo;
